export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automatisation",
    title: `Quand les informations d'arrivée sont-elles envoyées ?`,
    desc: `Activez chaque événement et décidez <strong>quand</strong> il est envoyé : lorsqu'<strong>un client</strong> termine son enregistrement, ou uniquement lorsque <strong>tous</strong> les clients de la réservation terminent leur enregistrement.`,
    loading: "Chargement de la configuration…",
    welcomeName: "Message de bienvenue",
    welcomeSub: "Le message de bienvenue que le client reçoit juste après avoir terminé son enregistrement.",
    documentName: "Document de politiques signé",
    documentSub: `C'est le document que le client signe lors du processus d'enregistrement. Nous l'envoyons en PDF afin qu'il l'ait sur son WhatsApp ou son e-mail.`,
    timingIndividual: `Lorsqu'un client termine son enregistrement`,
    timingAll: `Lorsque tous les clients de la réservation terminent l'enregistrement`,
    timingQuestion: "Quand est-il envoyé ?",
    eventOffNote: "Cet événement ne sera pas envoyé automatiquement.",
    infoBox: `Les modifications sont enregistrées automatiquement. La clé d'accès, lorsque le logement dispose d'une serrure connectée, suit sa propre configuration.`,
    loadError: "Impossible de charger la configuration.",
    saveError: `Impossible d'enregistrer la configuration. Veuillez réessayer.`,
  },
  checkinProcess: {
    colEmail: "E-mail",
    colSendDate: `Date d'envoi`,
    colStatus: "Statut",
    unspecified: "Non spécifié",
    complete: "Terminé",
    pending: "En attente",
  },
  listBookings: {
    title: "Liste des check-ins",
    subtitle: "Registre des arrivées de vos clients",
    accommodation: "Logement",
    all: "Tous",
    from: "Du",
    to: "Au",
    search: "Rechercher",
    today: `Aujourd'hui`,
    noDate: "Sans date",
    clear: "Effacer",
    exporting: "Exportation...",
    exportCheckins: "Exporter",
    ricevutaBtn: "Reçu de police",
    ricevutaTitle: "Reçu de la police italienne",
    ricevutaHint: "Le reçu officiel d'Alloggiati Web avec tous les check-ins envoyés chaque jour. Un jour télécharge un PDF ; plusieurs, un ZIP avec un PDF par jour (31 max).",
    ricevutaFrom: "Du",
    ricevutaTo: "Au",
    ricevutaAccount: "Compte police",
    ricevutaDownload: "Télécharger le PDF",
    ricevutaDownloading: "Téléchargement…",
    ricevutaCancel: "Annuler",
    ricevutaError: "Impossible de télécharger le reçu.",
    noAccommodation: "Sans logement",
    noReservation: "Sans réservation",
    travelerReport: "Fiche de voyageur (Mossos)",
    noRecords: "Aucun enregistrement",
    noRecordsFiltered: "Aucun enregistrement trouvé avec les filtres appliqués.",
    noCheckinsTitle: "Aucun check-in enregistré pour le moment",
    noCheckinsSub: "Lorsque vos clients auront terminé leur check-in, vous les verrez ici avec toutes leurs informations.",
    excelSuccess: "Check-ins téléchargés dans Excel",
    excelSuccessTitle: "Exportation terminée",
    excelError: `Nous n'avons pas pu exporter les check-ins`,
    errorTitle: "Erreur",
    listingNotIdentified: `Impossible d'identifier l'annonce du check-in`,
    comprobanteNotAvailable: `Le justificatif n'est pas encore disponible pour ce check-in`,
    comprobanteDownloadError: "Impossible de télécharger le justificatif",
  },
  modalFirstCheckin: {
    loading: "Chargement...",
    sendingLinkWait: "Envoi du lien de check-in, veuillez patienter...",
    phoneRequired: "Pour continuer, vous devez saisir le numéro WhatsApp",
    sendingLink: "Envoi du lien ...",
    almostThere: "Presque terminé, veuillez patienter...",
    sentSuccess: "Envoyé avec succès",
    sendError: `Erreur lors de l'envoi du check-in`,
    title: "Essayez dès maintenant un processus de check-in avec votre propre téléphone",
    enterWhatsapp: "Saisissez votre numéro WhatsApp",
    invalidNumber: `Numéro invalide. Assurez-vous d'inclure le préfixe "+".`,
    skip: "Ignorer",
    sendFirstCheckin: "Envoyer votre premier check-in",
    sendCheckin: "Envoyer le check-in",
  },
  tableRetriveCheckinPending: {
    colEmail: "E-mail",
    colSendDate: `Date d'envoi`,
    colStatus: "Statut",
    unspecified: "Non spécifié",
    complete: "Terminé",
    pending: "En attente",
    emptyMessage: `Vous n'avez pas encore de check-ins en cours`,
  },
  rerservationModal: {
    night: "nuit",
    nights: "nuits",
    minStayBanner: "La plage sélectionnée a une restriction de séjour minimum de {count} {nights} (règle OTA). Nuits sélectionnées : {selected}.",
    freeUnits: "Unités disponibles : {count}",
    noAvailabilityDetailed: "Aucune disponibilité pour ces dates. {details}",
    noAvailability: "Aucune disponibilité pour ces dates.",
    hotelAvailabilityError: "Impossible de valider la disponibilité (hôtel).",
    minStayWarning: `Un minimum de {count} nuits est requis pour le jour d'arrivée. Vous avez sélectionné {selected}.`,
    notEnoughAvailability: `Il n'y a pas assez de disponibilité. Unités disponibles : {count}.`,
    noAvailabilityDates: `Il n'y a aucune disponibilité pour les dates sélectionnées.`,
    departureAfterArrival: `Le départ doit être postérieur à l'arrivée.`,
    close: "Fermer",
    noMatches: "Aucune correspondance",
    noAccommodations: "Aucun logement",
    searchingGuests: "Recherche de clients...",
    noName: "Sans nom",
    priceLocked: "Le prix de la réservation ne peut pas être modifié.",
    otaMoveHint: "Vous pouvez la déplacer vers un autre logement de la même annonce ; le canal est prévenu.",
    otaMoveHintCuenta: "Vous pouvez la déplacer vers n'importe lequel de vos logements. S'il fait partie de la même annonce, le canal est prévenu.",
    otaRelocateNote: "C'est une autre annonce : elle est déplacée dans WACheckin, mais le canal la garde dans le logement où elle a été vendue. Ses modifications et son annulation vous parviendront toujours.",
    extrasTitle: "Autres options",
    extrasSub: "Cochez ce que vous facturez et la remise appliquée",
    quoteTitle: "Ce que facture votre réservation directe",
    quoteHint: "Cochez ce que vous voulez facturer sur cette réservation. Les nuits sont toujours incluses.",
    quoteOptions: "1 à cocher | {count} à cocher",
    quoteNoExtras: "Ce logement n'a ni frais de ménage ni frais configurés dans sa réservation directe.",
    quoteStay: "Séjour · {count} nuit | Séjour · {count} nuits",
    quoteExtraGuest: "Voyageur supplémentaire | {count} voyageurs supplémentaires",
    quoteDiscount: "Remises et promotions",
    quoteOccupancyDiscount: "Remise selon l'occupation",
    quoteCleaning: "Frais de ménage",
    quoteTotal: "Total",
    quoteUse: "Utiliser ce prix",
    quoteNoRate: "Pas de tarif pour ces dates : saisissez le prix vous-même.",
    quoteLinePrice: "Prix de ce logement",
    unitsAdd: "Ajouter un autre logement de l’annonce…",
    unitsGuests: "Voyageurs dans ce logement",
    unitsRemove: "Retirer de la réservation",
    unitsGroupError: "La réservation à plusieurs logements n’a pas pu être créée.",
    resendTitle: "Renvoyer le message de confirmation",
    resendSub: "Renvoie le modèle de confirmation au client.",
    resendNote: "Lors de la modification de la réservation, <strong>le modèle de confirmation sera renvoyé</strong> pour cette réservation.",
    saving: "Enregistrement...",
  },
};
